// EN
export const calendarHotel = {
  btn: {
    today: "Heute",
  },
  summary: {
    availableLabel: "Verfügbar",
  },
  tooltip: {
    closed: "Geschlossen",
    dragToCreate: "Ziehen zum Auswählen (Buchung anlegen)",
  },
  labels: {
    room: "Zimmer",
    rooms: "Zimmer",
    number: "NUMMER:",
    capacityIconAlt: "Kapazität",
    maintenanceBadge: "WARTUNG",
  },
  toasts: {
    reservationCreatedOk: "Buchung erfolgreich angelegt.",
    reservationCreateErrPrefix: "Die Buchung konnte nicht angelegt werden: ",
    roomChangedOk: "Zimmer erfolgreich gewechselt",
    roomChangedErr: "Fehler beim Zimmerwechsel",
    roomTypeChangedOk: "Buchung verschoben nach {type}",
  },
  warn: {
    selectTwoDays: "Wählen Sie mindestens zwei Tage aus (Check-in und Check-out).",
  },
  errors: {
    closedForBooking: "Ein geschlossenes Zimmer bzw. einen geschlossenen Zeitraum können Sie nicht buchen.",
    noAvailabilityTitle: "Keine Verfügbarkeit",
    noAvailabilityDetail: "Für diesen Typ sind an diesen Daten keine Zimmer verfügbar.",
    noRatesTitle: "Keine Tarife zugewiesen",
    noRatesDetail: "Für diesen Typ sind an diesen Daten keine Tarife verfügbar.",
    missingDataTitle: "Fehlende Daten",
    missingDataDetail: "Bitte füllen Sie alle Pflichtfelder aus.",
  },
  maintenanceModal: {
    titleFallback: "Zimmer",
    statusSection: "Status",
    closeForMaintenance: "Für Wartung sperren",
    open: "Öffnen",
    hint:
      "Ein Zimmer in Wartung kann nicht verkauft werden und seine Felder erscheinen rot. Bestehende Buchungen bleiben erhalten.",
    actions: {
      cancel: "Abbrechen",
      save: "Speichern",
      saving: "Wird gespeichert…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Neue Buchung erfassen",
    startDate: "Check-in",
    endDate: "Check-out",
    roomType: "Zimmertyp",
    roomTypePlaceholder: "Typ auswählen",
    quantity: "Anzahl der Zimmer",
    available: "verfügbar",
    guestName: "Verantwortlicher Gast",
    guestNamePlaceholder: "Für die Buchung verantwortliche Person",
    guests: "Anzahl der Gäste",
    guestsPlaceholder: "Anzahl der Gäste",
    phone: "Telefon",
    email: "E-Mail",
    notes: "Notiz",
    notesPlaceholder: "Interne Notizen zur Buchung (z. B. späte Ankunft, Babybett, Allergien…)",
    addType: "Weiteren Zimmertyp hinzufügen",
    price: "Preis",
    pricePlaceholder: "Preis eingeben",
    cancel: "Abbrechen",
    create: "Buchung anlegen",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Zu wenige Gäste",
    minGuestsDetail: "Für {rooms} Zimmer müssen es mindestens {min} Gäste sein.",
    maxGuestsTitle: "Gästelimit überschritten",
    maxGuestsDetail: "Maximal {maxPerRoom} Gäste pro Zimmer ({maxTotal} insgesamt bei {rooms} Zimmern).",
    maxRoomsTitle: "Limit überschritten",
    maxRoomsDetail: "Sie können nicht mehr als {max} Zimmer buchen.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Limit erreicht",
    limitDetail: "Sie können nicht mehr als 1 Angebot hinzufügen.",
  },
  taxes: {
    limitTitle: "Limit erreicht",
    limitDetail: "Sie können nicht mehr als 1 Steuer hinzufügen.",
  },
};
